<div class="unwrap">
  <div class="bg-cover">
    <div class="container container-md py-4">
      <div class="text-center mb-3 pb-3">
        <div class="h1 text-bold">Help Centre</div>
        <p>Contact Design Automator's help centre and access user guides.</p>
      </div>
    </div>
  </div>
</div>
<div class="container container-md">
  <form action="">
    <div class="input-group input-group-lg">
      <input class="form-control form-control-lg rounded-0" type="text" name="term" placeholder="Search"
             [(ngModel)]="searchKeyword"/>
      <div class="input-group-append">
        <button class="btn btn-info btn-lg b0 rounded-0" type="button" (click)="search()">
          <strong>Search</strong>
        </button>
      </div>
    </div>
  </form>
  <p class="my-3 py-4 text-muted text-center">
  </p>

  <div class="row" *ngIf="displayMode===0">
    <div class="col-lg-4">
      <div class="card b">
        <div class="card-body text-center">
          <a class="link-unstyled text-primary" (click)="navigateToPageByType('faq')">
            <em class="fa fa-5x fas fa-question-circle mb-3"></em>
            <br/>
            <span class="h4">FAQ</span>
            <br/>
            <div class="text-sm text-muted">View all &rarr;</div>
          </a>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="card b">
        <div class="card-body text-center">
          <a class="link-unstyled text-primary" (click)="navigateToPageByType('userguides')">
            <em class="fa fa-5x fas fa-book mb-3"></em>
            <br/>
            <span class="h4">User Guides</span>
            <br/>
            <div class="text-sm text-muted">View all &rarr;</div>
          </a>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="card b">
        <div class="card-body text-center">
          <a class="link-unstyled text-primary" (click)="navigateToPageByType('videos')">
            <em class="fa fa-5x fas fa-film mb-3"></em>
            <br/>
            <span class="h4">Videos</span>
            <br/>
            <div class="text-sm text-muted">View all &rarr;</div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="displayMode===1">
    <div class="col-lg-4" *ngFor="let pageContent of pageContents">
      <div class="card b">
        <div class="card-body text-center">
          <a class="link-unstyled text-primary" (click)="navigateToPageContentDetail(pageContent.id)">
            <!--<em class="fa fa-5x fa-television mb-3"></em>-->
            <img src="{{url}}HelpCenter/{{pageContent.image}}" style="max-width: 50px"/>
            <br/>
            <span class="h4">{{pageContent.title}}</span>
            <br/>
            <div class="text-sm text-muted">View all &rarr;</div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="displayMode===2">
    <div class="col-lg-4" *ngFor="let section of sections">
      <div class="card b">
        <div class="card-body text-center">
          <a class="link-unstyled text-primary" (click)="navigateToPageByType('sections',section.id)">
            <img src="{{'../../../../assets/img/icons/help/'+section.title.toLowerCase()+'.svg'}}" height="80"/>
            <br/>
            <span class="h4">{{section.title}}</span>
            <br/>
            <div class="text-sm text-muted">View all &rarr;</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
